/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_tariffsearch.js                                                                    */
/**********************************************************************************************************************/
/* Subscriptions TariffSearch */
HafasWebapp.prototype.subscriptions.TariffSearch = function (_me) {
  Hafas.ps.sub('/tariffsearch/postForm', Hafas.bind(_me.Controller.TariffSearch.postForm, _me));
  Hafas.ps.sub("/suggest/selectitem/TariffSearch_From", Hafas.bind(function (loc) {
    _me.Controller.TariffSearch.instance.setLocation("dep", loc);
    Hafas.Modules.Validation.resetErrorField('TariffSearch_From');
    if (Hafas('#TariffSearch_To')) {
      Hafas('#TariffSearch_To').focus();
    }
  }, _me));
  Hafas.ps.sub("/suggest/selectitem/TariffSearch_To", Hafas.bind(function (loc) {
    _me.Controller.TariffSearch.instance.setLocation("arr", loc);
    Hafas.Modules.Validation.resetErrorField('TariffSearch_To');
  }, _me));

  Hafas.ps.sub('/GUI/leaveContext/TariffSearch', Hafas.bind(_me.Controller.TariffSearch.cleanup, _me));
  Hafas.ps.sub('/GUI/closeView/TariffSearch', Hafas.bind(_me.Controller.TariffSearch.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/TariffSearch', Hafas.bind(_me.Controller.TariffSearch.restoreView, _me));

  Hafas.ps.sub('/dateTimePicker/selectDateTime/TariffSearchDTP', Hafas.bind(_me.Controller.TariffSearch.selectDateTimeFromPicker, _me));

  Hafas.ps.sub("/tariffsearch/clearInput", Hafas.bind(_me.Controller.TariffSearch.clearInput, _me));

  // JumpIn Commands
  Hafas.ps.sub('/tariffsearch/hideInputField', Hafas.bind(_me.Controller.TariffSearch.hideInputField, _me));
  Hafas.ps.sub('/tariffsearch/hideDate', Hafas.bind(_me.Controller.TariffSearch.hideDate, _me));
  Hafas.ps.sub('/tariffsearch/showTime', Hafas.bind(_me.Controller.TariffSearch.showTime,_me));
  Hafas.ps.sub('/tariffsearch/setDateOffsetMin',Hafas.bind(_me.Controller.TariffSearch.setDateOffsetMin,_me))
  Hafas.ps.sub('/tariffsearch/setDateOffsetMax',Hafas.bind(_me.Controller.TariffSearch.setDateOffsetMax,_me))
  Hafas.ps.sub('/tariffsearch/setMetaFilter', Hafas.bind(_me.Controller.TariffSearch.setMetaFilter, _me));
  Hafas.ps.sub('/tariffsearch/setTrfContext', Hafas.bind(_me.Controller.TariffSearch.setTariffContext, _me));

  Hafas.ps.sub('/tariffsearch/resultLoaded/', Hafas.bind(_me.Controller.TariffSearch.showResultOverview, _me));
  Hafas.ps.sub('/tariffsearch/resultfail/', Hafas.bind(_me.Controller.TariffSearch.showErrorPage, _me));
  Hafas.ps.sub('/tariffsearch/updateTariffFilter', Hafas.bind(_me.Controller.TariffSearch.updateTariffOverview, _me));
  Hafas.ps.sub('/tariffsearch/toggleFareSet', Hafas.bind(_me.Controller.TariffSearch.toggleFareSet, _me));
  Hafas.ps.sub('/tariffsearch/switchFromTo', Hafas.bind(_me.Controller.TariffSearch.switchFromTo, _me));
  Hafas.ps.sub('/tariffsearch/chooseVariant', Hafas.bind(_me.Controller.TariffSearch.chooseVariant, _me));
};
